// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11uy0","content":"styles_content__1KokU"};